import { useRef, useState, useEffect } from 'react';
import classes from './DragContainer.module.scss';
import { useTheme } from '../../utils/ThemeContext';

const DragContainer = ({ min, max, onBetChange, position, setPosition }) => {
  const containerRef = useRef(null);
  const innerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const startX = useRef(0);
  const startPosition = useRef(0);
  const { theme } = useTheme();
  const [containerWidth, setContainerWidth] = useState(0);
  const [innerWidth, setInnerWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current && innerRef.current) {
      setContainerWidth(containerRef.current.clientWidth);
      setInnerWidth(innerRef.current.clientWidth);
    }
  }, []);

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!isDragging) return;

      let clientX = e.clientX;
      if (e.touches && e.touches[0]) {
        clientX = e.touches[0].clientX; // Use the touch clientX if it's a touch event
      }

      let deltaX = clientX - startX.current;
      let newPosition = startPosition.current + deltaX;
      const maxX = containerWidth - innerWidth;

      if (newPosition < 0) newPosition = 0;
      if (newPosition > maxX) newPosition = maxX;

      setPosition(newPosition); // Update position in the parent component
    };

    const onMouseUp = () => {
      setIsDragging(false);
      const value = Math.round(
        min + (position / (containerWidth - innerWidth)) * (max - min),
      );
      onBetChange(value);
    };

    const onTouchEnd = () => {
      onMouseUp();
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('touchmove', onMouseMove, { passive: false }); // Adding touchmove
    document.addEventListener('touchend', onTouchEnd);

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('touchmove', onMouseMove);
      document.removeEventListener('touchend', onTouchEnd);
    };
  }, [
    isDragging,
    containerWidth,
    innerWidth,
    position,
    min,
    max,
    onBetChange,
    setPosition,
  ]);

  const onMouseDown = (e) => {
    setIsDragging(true);
    startX.current = e.clientX;
    startPosition.current = position;
  };

  const onTouchStart = (e) => {
    if (e.touches && e.touches[0]) {
      setIsDragging(true);
      startX.current = e.touches[0].clientX;
      startPosition.current = position;
    }
  };

  const value = Math.round(
    min + (position / (containerWidth - innerWidth)) * (max - min),
  );

  return (
    <>
      <div
        className={classes.outer}
        ref={containerRef}
        style={{ border: theme.border }}
      >
        <div
          className={classes.inner}
          ref={innerRef}
          style={{
            left: `${position}px`,
            transition: isDragging ? 'none' : 'left 0.3s ease-out',
            background: theme.btnsColor,
          }}
          onMouseDown={onMouseDown}
          onTouchStart={onTouchStart}
        >
          <div className={classes.threePointsCont}>
            <div className={classes.threePoints} />
            <div className={classes.threePoints} />
            <div className={classes.threePoints} />
          </div>
          {value} LL
        </div>
      </div>
      <div className={classes.maxMinPosition}>
        <span className={classes.numberStyle}>{min} </span>
        <span className={classes.numberStyle}>{max} </span>
      </div>
    </>
  );
};

export default DragContainer;
